import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const CurrencyContext = createContext(null);
export const useCurrency = () => useContext(CurrencyContext);

export const SHIPPING_BASE = 10000; // ₦10,000 reference

export const CurrencyProvider = ({ children }) => {
  const [geo, setGeo] = useState({ currency: "NGN", symbol: "\u20A6", divisor: 1, country: "NG" });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/geo")
      .then(({ data }) => setGeo(data))
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);

  const convert = useCallback(
    (baseNgn) => (geo.divisor === 1 ? baseNgn : Math.round(baseNgn / geo.divisor)),
    [geo.divisor]
  );

  const fmt = useCallback(
    (baseNgn) => geo.symbol + convert(baseNgn).toLocaleString(),
    [geo.symbol, convert]
  );

  const value = {
    ...geo,
    ready,
    convert,
    fmt,
    shippingBase: SHIPPING_BASE,
  };

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
};
